module.exports = __webpack_public_path__ + "img/petstairs21.9c07f422.jpg";